<template>
  <li class="nav-item px-2 text" style="text-align: left">
    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-dollar-sign"></i>
      <p>SI - Finanzas<i class="fas fa-angle-left right"></i></p>
    </a>
    <ul class="nav nav-treeview">
      <li class="nav-item" v-if="showOrdenesDeServicio">
        <router-link class="nav-link" to="/si-finanzas/ordenes-servicio">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Órdenes Servicio</p>
        </router-link>
      </li>
      <li class="nav-item" v-if="showContable">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Contable<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showCompra">
            <router-link class="nav-link" to="/si-finanzas/contable/compra">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Compra</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showVincularCostoCompra">
            <router-link
              class="nav-link"
              to="/si-finanzas/contable/vincular-costo-compra"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Vincular Costo Compra</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showVenta">
            <router-link class="nav-link" to="/si-finanzas/contable/venta">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Venta</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showVincularCostoVenta">
            <router-link
              class="nav-link"
              to="/si-finanzas/contable/vincular-costo-venta"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Vincular Costo Venta</p>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="showNoContable">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>No Contable<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showCompraNoContable">
            <router-link class="nav-link" to="/si-finanzas/no-contable/compra">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Compra</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showVincularCostoCompraNoContable">
            <router-link
              class="nav-link"
              to="/si-finanzas/no-contable/vincular-costo-compra"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Vincular Costo Compra</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showVincularCostoVentaNoContable">
            <router-link
              class="nav-link"
              to="/si-finanzas/no-contable/vincular-costo-venta"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Vincular Costo Venta</p>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="showResumenCliente">
        <router-link class="nav-link" to="/si-finanzas/resumen-cliente">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Resumen Cliente</p>
        </router-link>
      </li>
      <li class="nav-item" v-if="showResumenProveedor">
        <router-link class="nav-link" to="/si-finanzas/resumen-proveedor">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Resumen Proveedor</p>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:25
 */
export default {
  data(){
    return {
      showOrdenesDeServicio: false,
      showContable: false,
      showCompra: false,
      showVincularCostoCompra: false,
      showVenta: false,
      showVincularCostoVenta: false,
      showNoContable: false,
      showCompraNoContable: false,
      showVincularCostoCompraNoContable: false,
      showVincularCostoVentaNoContable: false,
      showResumenCliente: false,
      showResumenProveedor: false,

    }
  },
  methods: {
    superAdmin(){
      this.showOrdenesDeServicio = true;
      this.showContable = true;
      this.showCompra = true;
      this.showVincularCostoCompra = true;
      this.showVenta = true;
      this.showVincularCostoVenta = true;
      this.showNoContable = true;
      this.showCompraNoContable = true;
      this.showVincularCostoCompraNoContable = true;
      this.showVincularCostoVentaNoContable = true;
      this.showResumenCliente = true;
      this.showResumenProveedor = true;
    }
  },
  created(){
    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
    const servIntFinanzasRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 4);
    if( servIntFinanzasRoleStructure ){
      servIntFinanzasRoleStructure.sections.map( ({ idSection, subSections }) => {
        switch (idSection) {
          case 37: this.showOrdenesDeServicio = true; break;
          case 38: // Contable
            this.showContable = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 97: this.showCompra = true; break;
                case 98: this.showVincularCostoCompra = true; break;
                case 99: this.showVenta = true; break;
                case 100: this.showVincularCostoVenta = true; break;
                default: break;
              }
            });
            
            break;
          case 39: 
            this.showNoContable = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 101: this.showCompraNoContable = true; break;
                case 102: this.showVincularCostoCompraNoContable = true; break;
                case 103: this.showVincularCostoVentaNoContable = true; break;
                default: break;
              }
            });
            break;
          case 40: this.showResumenCliente = true; break;
          case 41: this.showResumenProveedor = true; break;

          default:
            break;
        }
      });
    }

    const servIntFinanzasUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 4);
    if( servIntFinanzasUserStructure ){
      servIntFinanzasUserStructure.sections.map( ({ idSection, subSections }) => {
        switch (idSection) {
          case 37: this.showOrdenesDeServicio = true; break;
          case 38: // Contable
            this.showContable = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 97: this.showCompra = true; break;
                case 98: this.showVincularCostoCompra = true; break;
                case 99: this.showVenta = true; break;
                case 100: this.showVincularCostoVenta = true; break;
                default: break;
              }
            });
            
            break;
          case 39: 
            this.showNoContable = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 101: this.showCompraNoContable = true; break;
                case 102: this.showVincularCostoCompraNoContable = true; break;
                case 103: this.showVincularCostoVentaNoContable = true; break;
                default: break;
              }
            });
            break;
          case 40: this.showResumenCliente = true; break;
          case 41: this.showResumenProveedor = true; break;

          default:
            break;
        }
      });
    }
  }
};
</script>

<style></style>
